export default "__VITE_ASSET__L6Bj1C40__"